import Select, {
  components,
  DropdownIndicatorProps,
  OptionProps,
  SingleValue,
  SingleValueProps,
} from 'react-select';
import clsx from 'clsx';

import indicator from '@/assets/icons/language-selector/fluent_ios-arrow-24-filled.svg';

import styles from './ContactSelect.module.scss';

export interface ContactOption {
  value: string;
  label: string;
  icon: string;
  link: string;
}

const CustomDropdownIndicator = (props: DropdownIndicatorProps<ContactOption, false>) => {
  const { selectProps } = props;

  return (
    <components.DropdownIndicator {...props}>
      <div
        className={clsx(styles.customDropdownIndicator, {
          [styles.customDropdownIndicator_rotated]: selectProps.menuIsOpen,
        })}
      >
        <img src={indicator} alt="Indicator" />
      </div>
    </components.DropdownIndicator>
  );
};

function CustomSingleValue({ data }: SingleValueProps<ContactOption, false>) {
  return (
    <div className={styles.customSingleValue}>
      <div className={styles.customSingleValue__icon}>
        <img src={data.icon} alt="Icon" />
      </div>
      <div className={styles.customSingleValue__label}>{data.label}</div>
    </div>
  );
}

type CustomOptionProps = OptionProps<ContactOption, false> & {
  isForModal?: boolean;
};

function CustomOption({ data, innerRef, innerProps, isSelected, isForModal }: CustomOptionProps) {
  return (
    <div
      ref={innerRef}
      {...innerProps}
      className={clsx(
        styles.customOption,
        { [styles.customOption_selected]: isSelected },
        { [styles.customOption_forModal]: isForModal },
      )}
    >
      <div className={styles.customSingleValue__icon}>
        <img src={data.icon} alt="Icon" />
      </div>
      <div className={styles.customOption__label}>{data.label}</div>
    </div>
  );
}

interface ContactSelectProps {
  options: ContactOption[];
  value: ContactOption;
  onChange: (newValue: SingleValue<ContactOption>) => void;
  className?: string;
  isForModal?: boolean;
}

export function ContactSelect({
  options,
  value,
  onChange,
  className,
  isForModal = false,
}: ContactSelectProps) {
  return (
    <Select
      className={clsx(styles.contactSelect, className)}
      unstyled
      isSearchable={false}
      isClearable={false}
      options={options}
      value={value}
      onChange={onChange}
      components={{
        DropdownIndicator: CustomDropdownIndicator,
        SingleValue: CustomSingleValue,
        Option: (props) => <CustomOption {...props} isForModal={isForModal} />,
      }}
      styles={{
        control: (base) => ({
          ...base,
          padding: '14px 20px',
          minHeight: 'auto',
          backgroundColor: isForModal ? '#f5f5f5' : '#ffffff',
          borderRadius: '15px',
          transition: 'all none',
          cursor: 'pointer',
        }),
        menu: (base) => ({
          ...base,
          zIndex: 10,
          marginTop: '5px',
          padding: '10px',
          backgroundColor: isForModal ? '#f5f5f5' : '#ffffff',
          borderRadius: '15px',
          overflow: 'hidden',
        }),
      }}
    />
  );
}
